import { setTimelineChronologySelectedEntryIds, TimelineChronologyType } from '@/store';
import { TIMELINE_CHRONOLOGY_TAGS } from '../constants';
import { api } from '../core';

export type TimelineEntryDeleteResponse = object;

interface TimelineEntryDeleteProps {
  caseId: string;
  entryIds: string[];
}

const timelineEntryDeleteApi = api.injectEndpoints({
  endpoints: (builder) => ({
    postTimelineEntryDelete: builder.query<TimelineEntryDeleteResponse, TimelineEntryDeleteProps>({
      query: ({ caseId, entryIds: entryIds }: TimelineEntryDeleteProps) => ({
        url: `timeline/entry/delete`,
        method: 'POST',
        body: {
          case_id: caseId,
          timeline_entry_ids: entryIds
        }
      }),
      async onQueryStarted(_, { dispatch, queryFulfilled }) {
        try {
          await queryFulfilled;

          dispatch(
            setTimelineChronologySelectedEntryIds({
              key: TimelineChronologyType.TIMELINE,
              data: []
            })
          );
          dispatch(api.util.invalidateTags([...TIMELINE_CHRONOLOGY_TAGS]));
        } catch (error) {
          if (error instanceof Error && error.name === 'AbortError') {
            console.log('Request was aborted');
          } else {
            console.error('Error in postTimelineEntryDelete in onQueryStarted:', error);
          }
        }
      },
      extraOptions: { maxRetries: 0 }
    })
  })
});

/**
 * Export hooks for usage in functional components, which are
 * auto-generated based on the defined endpoints
 */
export const { useLazyPostTimelineEntryDeleteQuery } = timelineEntryDeleteApi;
